export const common = {
  nav: {
    home: '홈',
    about: '소개',
    gimcheon: '2026 김천',
    announcement: '공지사항',
    contact: '연락처',
    login: '로그인',
    signUp: '회원가입',
    privacy: '개인정보 처리방침'
  },
  hero: {
    title: '김천 월드컵',
    subtitle: 'GIMCHEON WORLD CHAMPIONSHIPS',
    description: '',
    cta: '지금 등록',
    registerNow: '지금 등록',
    learnMore: '더 알아보기',
    guidelinesTitle: '대회 가이드라인',
    guidelinesEnglish: '영어 가이드라인',
    guidelinesKorean: '한국어 가이드라인',
    travelAgency: '공식 여행 및 관광 대행사',
    kombatGuidelines: '콤뱃 태권도 리그 가이드라인'
  },
  about: {
    title: '소개',
    subtitle: '',
    description: '수십 년간 태권도에 헌신하여 국제 대회에서 최고의 영예를 달성했습니다. 올림픽 메달부터 세계 선수권 타이틀까지, 이 여정은 무술 우수성에 대한 흔들리지 않는 헌신을 나타냅니다.',
    experience: '경력 년수',
    students: '훈련한 학생',
    medals: '국제 메달',
    stats: {
      years: '경력 년수',
      students: '훈련한 학생',
      medals: '국제 메달'
    },
    philosophy: '훈련 철학',
    philosophyText: '진정한 숙달은 신체 기술, 정신 훈련, 영적 성장의 완벽한 균형에서 나옵니다. 모든 학생은 자신만의 방식으로 챔피언이 될 잠재력을 가지고 있습니다.'
  },
  gimcheon: {
    badge: '다가오는 이벤트',
    title: '2026 김천 월드태권도챔피언십',
    mainTitle: '모든 태권도 선수를 위한 글로벌 오픈 챔피언십',
    description1: '2026 김천 세계 태권도 선수권 대회는 전 세계 선수들을 환영하는 국제 오픈 이벤트입니다. 이 독특한 챔피언십은 WT(올림픽), ITF(전통), 그리고 Kombat 태권도를 하나의 글로벌 무대에 모읍니다.',
    description2: '초보자부터 엘리트 선수까지, 어린이부터 마스터까지 — 모든 국적, 연령, 벨트 레벨이 환영받습니다.',
    description3: '',
    subtitle: '최고의 국제 태권도 선수권 대회',
    dateLabel: '이벤트 날짜',
    date: '2026년 7월 11-12일',
    eventDate: '2026.07.11-12',
    dateText: '날짜',
    locationLabel: '장소',
    location: '김천 스포츠 컴플렉스, 대한민국',
    venue: '김천 체육관',
    venueLocation: '경북 김천시 운동장길 1 김천종합운동장',
    categoriesLabel: '카테고리',
    categories: '모든 연령대 및 체급',
    deadline: '조기 등록 마감: 2026년 3월 31일',
    registerButton: '지금 등록',
    registerTitle: '2026 김천 월드택원도챔피언십 등록',
    joinUs: '',
    register: '등록',
    international: '국제 참가',
    internationalDesc: '50개국 이상의 선수들이 최고 수준의 태권도 우수성을 겨룹니다.',
    competition: '세계적 수준의 시설',
    competitionDesc: '최첨단 장비와 전문 심판이 있는 올림픽 표준 경기장.',
    streaming: '라이브 중계',
    streamingDesc: '전 세계 수백만 시청자에게 도달하는 전문 라이브 스트리밍 및 방송 중계.',
    cultural: '문화 교류',
    culturalDesc: '무술의 정신과 전통을 기념하는 워크숍, 세미나 및 문화 프로그램.',
    travelAgency: {
      title: '공식 파트너 여행사',
      description: '대회는 국제 참가자와 팀을 지원하기 위해 공식 파트너 여행사와 협력하여 운영됩니다.',
      servicesTitle: '아래 링크를 통해 다음을 찾을 수 있습니다:',
      service1: '선수 숙박 패키지',
      service2: '공항 픽업 및 현지 교통편',
      service3: '한국 문화 투어',
      service4: '훈련 캠프 및 대회 관련 여행 서비스',
      cta: '대회 참가를 더 쉽고 편안하게 만드세요.'
    }
  },
  training: {
    title: '훈련 및 수업',
    subtitle: '모든 레벨을 위한 프로그램',
    beginners: '초보자 프로그램',
    beginnersDesc: '태권도를 처음 접하는 분들에게 완벽합니다. 지원적인 환경에서 기본 기술, 기본 품새 및 필수 규율을 배웁니다.',
    intermediate: '중급 훈련',
    intermediateDesc: '복잡한 기술, 겨루기 연습 및 경쟁 준비로 기술을 향상시킵니다. 힘과 자신감을 키웁니다.',
    advanced: '고급 및 경쟁',
    advancedDesc: '진지한 경쟁자를 위한 엘리트 훈련. 고급 기술, 전략적 겨루기 및 챔피언십 수준의 성과를 마스터합니다.',
    private: '개인 코칭',
    privateDesc: '세계 챔피언과의 일대일 세션. 특정 목표와 능력에 맞춘 개인화된 훈련 계획.',
    kids: '어린이 수업',
    kidsDesc: '5-12세 어린이를 위한 재미있고 매력적인 수업. 태권도를 통해 규율, 존중, 조정 및 자신감을 개발합니다.',
    adults: '성인 수업',
    adultsDesc: '모든 체력 수준의 성인을 위한 종합 훈련. 건강 개선, 호신술 학습 및 개인 성장 달성.'
  },
  gallery: {
    title: '갤러리 및 포스터',
    subtitle: '영광의 순간',
    viewAll: '모든 사진 보기'
  },
  contact: {
    title: '문의하기',
    subtitle: '',
    teamName: '팀 이름',
    teamNamePlaceholder: '팀 이름을 입력하세요',
    country: '국가',
    countryPlaceholder: '국가를 선택하세요',
    contactPerson: '담당자 이름',
    contactPersonPlaceholder: '담당자 이름을 입력하세요',
    name: '이름',
    email: '이메일',
    emailPlaceholder: '이메일을 입력하세요',
    phone: '전화번호',
    phoneNumber: '전화번호',
    contactMethod: '선호하는 연락 방법',
    contactValue: '연락처',
    phoneLabel: '전화번호',
    whatsappLabel: 'WhatsApp 번호',
    telegramLabel: 'Telegram 사용자명',
    wechatLabel: 'WeChat ID',
    phonePlaceholder: '+82 10-1234-5678',
    whatsappPlaceholder: '+82 10-1234-5678',
    telegramPlaceholder: '@username',
    wechatPlaceholder: 'WeChat ID',
    message: '메시지',
    messagePlaceholder: '팀 및 등록 세부 정보를 알려주세요',
    messageLimit: '최대 500자',
    submit: '제출',
    submitting: '제출 중...',
    successMessage: '정보를 주셔서 감사합니다. 24시간 이내에 연락드리겠습니다.',
    errorMessage: '등록 제출에 실패했습니다. 다시 시도해 주세요.',
    send: '메시지 보내기',
    info: '연락처 정보',
    address: '주소',
    addressText: '경북 김천시 운동장길 1 김천종합운동장',
    hours: '운영 시간',
    hoursText: '월요일 - 금요일: 오전 6:00 - 오후 9:00\n토요일: 오전 8:00 - 오후 6:00\n일요일: 오전 9:00 - 오후 3:00',
    followUs: '팔로우하기'
  },
  footer: {
    tagline: '주최 사단법인 세계스포츠위원회',
    quickLinks: '빠른 링크',
    copyright: '© 2025 GCWC 태권도. 모든 권리 보유.',
    poweredBy: 'Powered by Readdy'
  },
  popup: {
    badge: '대회 등록',
    title: '2026 김천 월드태권도챔피언십',
    dateLabel: '날짜',
    date: '2026년 7월 11-12일',
    locationLabel: '장소',
    location: '경북 김천시 운동장길 1 김천종합운동장',
    categoriesLabel: '카테고리',
    categories: '모든 연령대 및 체급',
    highlightsTitle: '대회 하이라이트',
    highlight1: '국제 선수',
    highlight2: '올림픽 표준 경기 시설',
    highlight3: '라이브 스트리밍 및 전문 중계',
    highlight4: '문화 교류 프로그램 및 워크숍',
    applyButton: '신청하기',
    registerButton: '지금 등록',
    registerHereButton: '등록하기',
    closeButton: '닫기',
    deadline: '조기 등록 마감: 2026년 3월 31일'
  },
  competitionButton: {
    text: '대회 등록',
    shortText: '대회 등록'
  },
  login: {
    title: '환영합니다',
    subtitle: '계정에 로그인하여 계속하세요',
    email: '이메일 주소',
    emailPlaceholder: '이메일을 입력하세요',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 입력하세요',
    rememberMe: '로그인 상태 유지',
    forgotPassword: '비밀번호를 잊으셨나요?',
    loginButton: '로그인',
    or: '또는',
    googleLogin: 'Google로 계속하기',
    facebookLogin: 'Facebook으로 계속하기',
    noAccount: '계정이 없으신가요?',
    signUpLink: '회원가입',
    termsText: '로그인하면 다음에 동의하는 것입니다',
    termsLink: '이용약관'
  },
  signup: {
    title: '계정 만들기',
    subtitle: '오늘 태권도 커뮤니티에 가입하세요',
    fullName: '이름',
    fullNamePlaceholder: '이름을 입력하세요',
    email: '이메일 주소',
    emailPlaceholder: '이메일을 입력하세요',
    password: '비밀번호',
    passwordPlaceholder: '비밀번호를 만드세요',
    confirmPassword: '비밀번호 확인',
    confirmPasswordPlaceholder: '비밀번호를 확인하세요',
    phone: '전화번호',
    phonePlaceholder: '전화번호를 입력하세요',
    dateOfBirth: '생년월일',
    beltLevel: '현재 벨트 레벨',
    selectBelt: '벨트 레벨을 선택하세요',
    whiteBelt: '흰띠',
    yellowBelt: '노란띠',
    greenBelt: '초록띠',
    blueBelt: '파란띠',
    redBelt: '빨간띠',
    blackBelt: '검은띠',
    agreeText: '다음에 동의합니다',
    termsLink: '이용약관',
    and: '및',
    privacyLink: '개인정보 보호정책',
    signUpButton: '계정 만들기',
    or: '또는',
    googleSignUp: 'Google로 가입하기',
    facebookSignUp: 'Facebook으로 가입하기',
    haveAccount: '이미 계정이 있으신가요?',
    loginLink: '로그인',
    passwordMismatch: '비밀번호가 일치하지 않습니다',
    agreeTermsRequired: '이용약관에 동의해야 합니다'
  },
  privacyPolicy: {
    title: '개인정보 처리방침',
    lastUpdated: '최종 업데이트',
    introduction: {
      title: '소개',
      content: 'GCWC (김천 월드 챔피언스)에 오신 것을 환영합니다. 저희는 귀하의 개인정보를 존중하며 보호하기 위해 최선을 다하고 있습니다. 본 개인정보 처리방침은 귀하가 저희 웹사이트를 방문할 때 개인정보를 어떻게 관리하는지, 그리고 법률이 귀하를 어떻게 보호하는지 알려드립니다.'
    },
    infoCollect: {
      title: '수집하는 정보',
      content: '저희는 다음과 같은 다양한 종류의 개인정보를 수집, 사용, 저장 및 전송할 수 있습니다:',
      item1: '신원 정보: 이름, 성, 사용자명 또는 유사한 식별자',
      item2: '연락처 정보: 이메일 주소 및 전화번호',
      item3: '기술 정보: 인터넷 프로토콜(IP) 주소, 브라우저 유형 및 버전, 시간대 설정 및 위치, 운영 체제 및 플랫폼',
      item4: '사용 정보: 웹사이트, 제품 및 서비스 사용 방법에 대한 정보'
    },
    howWeUse: {
      title: '정보 사용 방법',
      content: '저희는 법률이 허용하는 경우에만 귀하의 개인정보를 사용합니다. 가장 일반적으로 다음과 같은 경우에 개인정보를 사용합니다:',
      item1: '새로운 학생 또는 회원으로 등록',
      item2: '대회 등록 처리 및 관리',
      item3: '서비스 변경 사항 통지를 포함한 귀하와의 관계 관리',
      item4: '웹사이트, 제품/서비스, 마케팅 또는 고객 관계 개선'
    },
    adsense: {
      title: 'Google 애드센스 및 광고',
      content: '저희는 웹사이트에 광고를 표시하기 위해 Google 애드센스를 사용합니다. Google 애드센스는 쿠키를 사용하여 귀하의 이전 웹사이트 방문 또는 다른 웹사이트 방문을 기반으로 광고를 제공합니다.',
      cookies: 'Google의 광고 쿠키 사용을 통해 Google과 파트너는 귀하의 사이트 방문 및/또는 인터넷의 다른 사이트 방문을 기반으로 광고를 제공할 수 있습니다.',
      optOut: '다음을 방문하여 맞춤 광고를 선택 해제할 수 있습니다:'
    },
    cookies: {
      title: '쿠키 및 추적 기술',
      content: '저희 웹사이트는 쿠키를 사용하여 다른 사용자와 구별합니다. 이를 통해 웹사이트를 탐색할 때 좋은 경험을 제공하고 사이트를 개선할 수 있습니다. 사용하는 쿠키 유형은 다음과 같습니다:',
      item1: '필수 쿠키: 웹사이트 운영에 필요한 쿠키',
      item2: '분석/성능 쿠키: 방문자 수를 인식 및 계산하고 방문자가 웹사이트를 이동하는 방법을 확인할 수 있는 쿠키',
      item3: '기능 쿠키: 웹사이트로 돌아올 때 귀하를 인식하는 데 사용되는 쿠키'
    },
    security: {
      title: '데이터 보안',
      content: '저희는 귀하의 개인정보가 실수로 분실, 사용 또는 무단 액세스, 변경 또는 공개되는 것을 방지하기 위해 적절한 보안 조치를 취하고 있습니다. 비즈니스상 알아야 할 필요가 있는 직원, 대리인, 계약자 및 기타 제3자로 개인정보 액세스를 제한합니다.'
    },
    thirdParty: {
      title: '제3자 링크',
      content: '저희 웹사이트에는 제3자 웹사이트, 플러그인 및 애플리케이션에 대한 링크가 포함될 수 있습니다. 해당 링크를 클릭하거나 연결을 활성화하면 제3자가 귀하에 대한 데이터를 수집하거나 공유할 수 있습니다. 저희는 이러한 제3자 웹사이트를 통제하지 않으며 개인정보 보호정책에 대해 책임지지 않습니다.'
    },
    children: {
      title: '어린이 개인정보 보호',
      content: '저희 서비스는 최소 13세 이상의 개인을 대상으로 합니다. 저희는 13세 미만 어린이로부터 의도적으로 개인정보를 수집하지 않습니다. 13세 미만 어린이가 개인정보를 제공한 것을 알게 되면 해당 정보를 삭제하는 조치를 취할 것입니다.'
    },
    rights: {
      title: '귀하의 권리',
      content: '특정 상황에서 귀하는 개인정보와 관련하여 데이터 보호법에 따른 권리를 갖습니다:',
      item1: '개인정보 액세스 요청',
      item2: '개인정보 수정 요청',
      item3: '개인정보 삭제 요청',
      item4: '개인정보 처리 반대'
    },
    changes: {
      title: '개인정보 처리방침 변경',
      content: '저희는 때때로 개인정보 처리방침을 업데이트할 수 있습니다. 이 페이지에 새로운 개인정보 처리방침을 게시하고 상단의 "최종 업데이트" 날짜를 업데이트하여 변경 사항을 알려드립니다.'
    },
    contact: {
      title: '문의하기',
      content: '본 개인정보 처리방침 또는 개인정보 보호 관행에 대해 질문이 있으시면 다음으로 문의하십시오:'
    }
  }
};
